import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Layout from '../components/Layout'
import Hero from '../components/sections/Hero'
import About from '../components/sections/About'
import Disciplines from '../components/sections/Disciplines'
import Gallery from '../components/sections/Gallery'
import Arsenal from '../components/sections/Arsenal'
import Events from '../components/sections/Events'
import Pricing from '../components/sections/Pricing'
import Reviews from '../components/sections/Reviews'
import Contact from '../components/sections/Contact'
import MapSection from '../components/sections/Map'

export default function Home() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '')
      const el = document.getElementById(id)
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }
  }, [location])

  return (
    <Layout>
      <Helmet>
        <title>Strefa TOP – ASG i Paintball Opole | Tarnów Opolski</title>
        <meta name="description" content="Strefa TOP – najlepsze pole ASG i paintball w okolicach Opola (Tarnów Opolski). Eventy firmowe, wieczory kawalerskie, urodziny, turnieje. Teren leśny, pełne wyposażenie w cenie. Zadzwoń: +48 888 460 037" />
        <link rel="canonical" href="https://strefatop.pl/" />
      </Helmet>
      <Hero />
      <About />
      <Disciplines />
      <Gallery />
      <Arsenal />
      <Events />
      <Pricing />
      <Reviews />
      <Contact />
      <MapSection />
    </Layout>
  )
}
